import { useCallback } from 'react';
import { useEventSpeakers } from './useEventSpeakers';

export function useEventSpeaker(eventId, speakerId) {
    const filter = useCallback((s) => s.id == speakerId, [speakerId]),
        speakers = useEventSpeakers(eventId, {
            filter,
        });

    return speakers[0]??null;
}
